module.exports = __webpack_public_path__ + "static/img/8.47b5f9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/8.png
// module id = +ruu
// module chunks = 0